import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import castArray from 'lodash/castArray';
import { assignConversationToExpertWithoutSelect, rejectConversationFromExpert } from 'actions';
import { removeNotification } from 'actions/notificationActions';
import { TICKET_ACTION_SOURCES } from 'analytics/ticketEventAnalytics';
import ContextualPopover from 'components/popups/ContextualPopover/ContextualPopover';
import { extractNominatedTickets } from 'extractFromState';

export default function NominatedPopover({ ticket }) {
  const dispatch = useDispatch();
  const allNominatedTickets = useSelector(extractNominatedTickets).allTickets;

  const message = ticket.lastCustomerMessageBody ?? ticket.ticketBody;

  // Intercom messages are stored with <p> tags. Remove them before rendering the message body.
  const normalizedMessage = message.replace(/<\/?p[^>]*>/g, '');

  const handleTake = async () => {
    await dispatch(assignConversationToExpertWithoutSelect(ticket, TICKET_ACTION_SOURCES.LIVE_CHAT_POPUP));
  };

  const handleReject = async () => {
    dispatch(removeNotification(ticket.ticketId));
    await dispatch(rejectConversationFromExpert(ticket.ticketId));
  };

  return (
    allNominatedTickets.includes(ticket.ticketId) && (
      <ContextualPopover
        labelButtonsWithActions={[
          ['Take', handleTake],
          ['Reject', handleReject],
        ]}
        ticket={ticket}
        ticketAssigned={false}
        messages={castArray(normalizedMessage)}
      />
    )
  );
}
